export const RENTAL_EXPERIENCE_CTA_STRINGS = {
  title: 'Discover the magic of renting a Belong home!',
  onTime: 'By paying rent on time, you build towards homeownership.',
  manage: 'Manage your home on the go with the Belong app.',
  learnMore: 'Learn more',
  standards:
    'Receive consistent, quality care with Belong’s Open\u00a0Standards.',
  stress_free:
    'A stress-free experience, with your very own Concierge, and\u00a024/7\u00a0Support.',
  belong_app:
    'Manage your home from the Belong App, with 30k+ Pros at your\u00a0fingertips.',
};
